import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from '@epoch-ui/lib/utils';
import { BORDER_GREY } from 'constants/colours';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <div className="tw-relative">
    <TabsPrimitive.List
      ref={ref}
      className={cn(
        'tw-inline-flex tw-w-full tw-items-center tw-justify-start tw-gap-4 tw-pb-[2px]',
        className
      )}
      {...props}
    />
    <div
      style={{
        position: 'absolute',
        bottom: 2,
        left: 0,
        width: '100%',
        height: '2px',
        backgroundColor: `${BORDER_GREY}`,
        zIndex: 0
      }}
    />
  </div>
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        'tw-group !tw-relative !tw-z-[1] tw-border-x-0 tw-border-b-2 tw-border-t-0 tw-border-solid tw-px-0 tw-pb-[14px] tw-text-base tw-font-medium tw-leading-4 tw-transition-all tw-duration-150 hover:tw-text-primary-blue focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-blue focus-visible:tw-ring-offset-2 data-[state=active]:tw-border-primary-blue data-[state=inactive]:tw-border-border-grey  data-[state=active]:tw-text-primary-blue',
        className
      )}
      {...props}
    />
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

const TabsBadge = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement> & { active?: boolean }
>(({ className, active, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'tw-ml-2 tw-inline-block tw-rounded-xl tw-px-2 tw-py-1 tw-text-sm tw-font-medium',
      'group-data-[state=active]:tw-bg-primary-blue group-data-[state=active]:tw-text-white',
      active ? 'tw-bg-primary-blue tw-text-white' : 'tw-bg-light-grey tw-text-black',
      'group-hover:tw-bg-primary-blue group-hover:tw-text-white',
      className
    )}
    {...props}
  />
));
TabsBadge.displayName = 'TabsBadge';

export { Tabs, TabsList, TabsTrigger, TabsContent, TabsBadge };
